import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  expiresAtUtc: null,
  username: null,
  fullName: null,
  mustChangePassword: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    credentialsSet: (state, action) => {
      const { token, expiresAtUtc, username, fullName, mustChangePassword } =
        action.payload;
      state.token = token;
      state.expiresAtUtc = expiresAtUtc;
      state.username = username;
      state.fullName = fullName;
      state.mustChangePassword = Boolean(mustChangePassword);
    },
    loggedOut: () => initialState,
  },
});

export const { credentialsSet, loggedOut } = authSlice.actions;
export default authSlice.reducer;

export const selectIsAuthenticated = (state) => Boolean(state.auth.token);
export const selectAuth = (state) => state.auth;
